import {
    ListenerMiddlewareInstance,
    createListenerMiddleware,
} from "@reduxjs/toolkit";
import { authApi } from "../../services/auth";

export const listenLoginMiddleware = createListenerMiddleware();
export const listenRegisterMiddleware = createListenerMiddleware();

type Matcher = typeof authApi.endpoints.login.matchFulfilled;
function listenTokenMiddleware(
    listener: ListenerMiddlewareInstance,
    matcher: Matcher
) {
    listener.startListening({
        matcher: matcher,
        effect: async (action, listenerApi) => {
            listenerApi.cancelActiveListeners();
            if (action.payload.token) {
                localStorage.setItem("token", action.payload.token);
            }
        },
    });
}

listenTokenMiddleware(
    listenLoginMiddleware,
    authApi.endpoints.login.matchFulfilled
);
listenTokenMiddleware(
    listenLoginMiddleware,
    authApi.endpoints.register.matchFulfilled
);
